let rootSelector = state => state.platform;
const platformSelector = state => rootSelector(state).platform;

// Required to set the root selector externally, since the module isn't aware of the
// global state shape.
export const setRootSelector = selector => {
  rootSelector = selector;
};

export const getPlatform = state => platformSelector(state);